/* app/js/src/components/common/autocomplete/autocomplete.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.ul-container {
  display: flex;
}
.ul-container > div:first-child {
  flex: 1;
  min-width: 90px;
  margin-right: 5px;
}
.ul-container > div:not(:first-child) {
  flex: 5;
  position: relative;
  padding: 0 15px;
}
ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
  border: 1px solid #e1e6eb;
  position: absolute;
  z-index: 1;
  background-color: #ffffff;
  max-height: 190px;
  overflow-x: hidden;
  overflow-y: scroll;
  left: 0;
  width: 100%;
}
ul li {
  margin: 0;
  color: #232f3a;
  font-size: 0.9em;
  padding: 5px 12px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
ul li:hover {
  background-color: #f1f3f4;
}
ul li.selected {
  background-color: #f1f3f4;
}
ul.hidden {
  visibility: hidden;
}
:host(.top) ul {
  bottom: 0;
  margin-bottom: 59px;
}
:host(.bottom) ul {
  top: 0;
  margin-top: -30px;
}
/*# sourceMappingURL=autocomplete.component.css.map */
